<figure>
    <img src="/assets/imgs/404.jpg" alt="not-found" class="image"/>
    <h3 class="title">Ohh! Page not found</h3>
    <p class="text">
        It seems we can't find what you're looking for.
        <br />
        Go back to
        <a routerLink="/" class="link"> Homepage</a>
    </p>
</figure>